import React from "react";
import { graphql } from "gatsby";
import { Box, Typography, useTheme } from "@material-ui/core";
import { ContentListFragment as Props } from "./__generated__/ContentListFragment";
import { OverflowBox } from "./styles";
import { ContentCard } from "./ContentCard";

const ContentList: React.FunctionComponent<Props> = ({ title, items }) => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between">
      <Box
        width="100%"
        paddingX={{ xs: 2, md: 0 }}
        paddingY={{ xs: 2, md: 5 }}
        // padding={{ xs: "47px 0 44px 16px", lg: "47px 0 44px 0" }}
        borderTop={`1px solid ${theme.palette.grey[400]}`}
        marginBottom={1}
      >
        <Typography variant="h5">{title}</Typography>
      </Box>

      <OverflowBox>
        {items.map((item, i) => (
          <ContentCard key={`${item} ${i}`} item={item} />
        ))}
      </OverflowBox>
    </Box>
  );
};

export const ContentListFragment = graphql`
  fragment ContentListFragment on DatoCmsCModuleContentList {
    title
    items {
      title
      titlePrefix
      cta
      link
      image {
        url
      }
    }
    model {
      id
      apiKey
    }
  }
`;

export default React.memo(ContentList);
